import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import { BILLING_ENABLED } from "../config/features";
import { useMainApi } from "../provider/main-api.provider";
import "./MainHeading.css";

interface MainHeadingProps {
  title?: React.ReactNode;
  subTitle?: string;
}

const IDEAS_URL = "https://theunplan.featurebase.app/";

const MainHeading = ({ title, subTitle }: Readonly<MainHeadingProps>) => {
  const { me } = useMainApi();
  const hasTitleBlock = Boolean(title || subTitle);

  const openIdeas = () => {
    window.open(IDEAS_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`main-heading${hasTitleBlock ? "" : " main-heading--actions-only"}`}>
      {hasTitleBlock && (
        <div className="main-heading__copy">
          {title && <h3 className="main-heading__title">{title}</h3>}
          {subTitle && <div className="subtitle">{subTitle}</div>}
        </div>
      )}

      <div className="main-heading__actions">
        <button type="button" className="main-heading__ideas-btn" onClick={openIdeas}>
          <LightbulbOutlinedIcon sx={{ fontSize: 17 }} />
          Ideas
        </button>
        {BILLING_ENABLED && !me?.has_subscription && (
          <a href="/plans" className="main-heading__upgrade-btn">
            <WorkspacePremiumOutlinedIcon sx={{ fontSize: 16 }} />
            Upgrade
          </a>
        )}
      </div>
    </div>
  );
};

export default MainHeading;
